import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoalValidation = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "sparkles 1",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20 2.66667C21.2587 8.25452 23.4387 10.6722 29.3333 12C23.7455 13.2587 21.3279 15.4387 20 21.3333C18.7413 15.7455 16.5613 13.3278 10.6667 12C16.5613 10.6722 18.7413 8.25452 20 2.66667Z",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M9.33333 16C10.2818 20.2105 12.0087 21.7676 16 22.6667C11.7895 23.6151 10.2324 25.342 9.33333 29.3333C8.38488 25.1228 6.65799 23.5657 2.66667 22.6667C6.87715 21.7183 8.43424 19.9913 9.33333 16Z",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgGoalValidation;
